"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setProgressBarStatus = exports.setProgressBarCurrent = exports.setProgressBar = exports.initialState = exports["default"] = void 0;
var _reduxActions = require("redux-actions");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = exports.initialState = {
  progressBar: []
};

/* Anatomy of a progressBar object
 * progressBar = [
 *   {
 *     flowData: {
 *       flowHandle_pawnId: status (one of 'not_started', 'started', 'completed')
 *     },
 *     isCurrent: bool,
 *     isMilestone: bool,
 *     status: overallstatus (one of 'not_started', 'started', 'completed')
 *   }
 * ];
 *
 */

// Actions
var SET_PROGRESS_BAR = 'assignment/player/SET_PROGRESS_BAR';
var SET_PROGRESS_BAR_CURRENT = 'assignment/player/SET_PROGRESS_BAR_CURRENT';
var SET_PROGRESS_BAR_STATUS = 'assignment/player/SET_PROGRESS_BAR_STATUS';

// Action Creators
var setProgressBar = exports.setProgressBar = (0, _reduxActions.createAction)(SET_PROGRESS_BAR);
var setProgressBarCurrent = exports.setProgressBarCurrent = (0, _reduxActions.createAction)(SET_PROGRESS_BAR_CURRENT);
var setProgressBarStatus = exports.setProgressBarStatus = (0, _reduxActions.createAction)(SET_PROGRESS_BAR_STATUS);

// Helper Methods

// Reducers
var _default = exports["default"] = (0, _reduxActions.handleActions)(_defineProperty(_defineProperty(_defineProperty({}, SET_PROGRESS_BAR, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    progressBar: action.payload
  });
}), SET_PROGRESS_BAR_CURRENT, function (state, action) {
  var updatedProgressBar = [];
  for (var i = 0; i < state.progressBar.length; i++) {
    var progressObj = state.progressBar[i];
    if (Object.keys(progressObj.flowData).includes(action.payload)) {
      updatedProgressBar.push(Object.assign(progressObj, {
        isCurrent: true
      }));
      continue;
    }
    updatedProgressBar.push(Object.assign(progressObj, {
      isCurrent: false
    }));
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    progressBar: updatedProgressBar
  });
}), SET_PROGRESS_BAR_STATUS, function (state, action) {
  var updatedProgressBar = [];
  var newStatus = action.payload.status;
  for (var i = 0; i < state.progressBar.length; i++) {
    var progressObj = Object.assign({}, state.progressBar[i]);
    var flowHandles = Object.keys(progressObj.flowData);
    if (!flowHandles.includes(action.payload.handle)) {
      updatedProgressBar.push(progressObj);
      continue;
    }
    // Must determine if overall status should change
    var allCompleted = true;
    for (var j = 0; j < flowHandles.length; j++) {
      // We can't move backwards from 'completed'
      if (progressObj.flowData[flowHandles[j]] === 'completed') {
        continue;
      }
      if (flowHandles[j] === action.payload.handle) {
        progressObj.flowData[flowHandles[j]] = newStatus;
        if (newStatus === 'completed') {
          continue;
        }
      }
      allCompleted = false;
    }
    progressObj.status = allCompleted ? 'completed' : 'started';
    updatedProgressBar.push(progressObj);
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    progressBar: updatedProgressBar
  });
}), initialState);